import {
  AlphaQuoteEvaluationStatus,
  type FieldDefinition,
  type QuantityBreak,
  type QuantityBreakField,
  type QuantityBreakFieldId,
  type QuantityBreakFieldKey,
  quantityBreakFieldModel,
  type QuantityBreakValueId,
} from '@snap-types/models/auto-configurator/state';
import { generateUUID } from '@ui/util/uuid';

import {
  buildBooleanValue,
  buildDecimalValue,
  buildNumberValue,
} from './value';

export function buildQuantityBreakFieldId(
  key: QuantityBreakFieldKey,
): QuantityBreakFieldId {
  return {
    model: quantityBreakFieldModel,
    key,
  };
}

export function buildQuantityBreakValueId(
  key: QuantityBreakFieldKey,
  uuid: string,
): QuantityBreakValueId {
  return {
    model: quantityBreakFieldModel,
    key,
    uuid,
  };
}

export function buildQuantityBreakField(
  key: QuantityBreakFieldKey,
  definition: FieldDefinition,
): QuantityBreakField {
  return {
    model: quantityBreakFieldModel,
    key,
    definition,
  };
}

export function buildQuantityBreak(
  opts: Partial<QuantityBreak> = {},
): QuantityBreak {
  const uuid = opts.uuid ?? generateUUID();

  return {
    uuid,

    isPending: false,
    lineItemUuid: '',
    evaluationStatus: AlphaQuoteEvaluationStatus.CALCULATED,
    calculatedData: null,

    quantity: buildDecimalValue(),
    sems1Cost: buildDecimalValue(),
    sems2Cost: buildDecimalValue(),
    osp2Price: buildDecimalValue(),
    osp3Price: buildDecimalValue(),

    userGrossMargin: buildDecimalValue(),
    grossMarginIsOverridden: buildBooleanValue(false),
    userUnitPrice: buildDecimalValue(),
    unitPriceIsOverridden: buildBooleanValue(false),
    userLeadTimeWeeks: buildNumberValue(),
    leadTimeWeeksIsOverridden: buildBooleanValue(false),

    ...opts,
  };
}
